import { render, staticRenderFns } from "./paginationComponent.vue?vue&type=template&id=75667521&scoped=true&"
import script from "./paginationComponent.vue?vue&type=script&lang=js&"
export * from "./paginationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75667521",
  null
  
)

export default component.exports